const { makeStyles } = require("@mui/styles");
const { createTheme } = require("@mui/material/styles");
const { green } = require("@mui/material/colors");

const drawerWidth = 320;

export const IframeControlHeight = 58;
/**
 * Class to unify all the styles of the layout.
 */
export const useStylesLayout = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    color: "white",
    height: "100%",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    maxHeight: 60,
    //color: 'white'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    color: "white",
  },
  menuButton: {
    marginRight: 36,
    color: "white",
    border: "none",
    outline: "none",
    boxShadow: "none",
  },
  rightToolbar: {
    marginLeft: "auto",
    marginRight: -12,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    backgroundColor: "#324148",
    color: "white",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: theme.palette.primary.main,
    color: "white",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255, 255, 255, 0.45) rgba(255, 255, 255, 0.12)",
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "100%",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(255, 255, 255, 0.45)",
      borderRadius: "10px",
      border: "2px solid rgba(6, 34, 79, 0.75)",
      minHeight: "36px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.62)",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    color: "white",
    //marginTop : 64
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: "0px 0px 0px 0",
    height: "100%",
    minHeight: 0,
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  icon: {
    color: "white",
    stroke: "none",
  },
  text: {
    color: "white",
    paddingLeft: 0,
    textAlign: "left",
    textShadow: "none",
    WebkitTextStroke: "0 transparent",
  },
  pageHeader: {
    marginTop: 3,
    marginLeft: 4,
    marginRight: 2,
    marginBottom: 0,
    padding: 10,
    height: IframeControlHeight,
  },
  pageContent: {
    padding: "auto",
    //height: '88vh',
    height: `calc(100% - ${77}px)`,
    overflow: "hidden",
    marginBottom: "-7px",
    border: "0px",
    zIndex: 0,
    paddingLeft: "calc(5%)",
    backgroundColor: "white",
  },
  logo: {
    maxWidth: 100,
    cursor: "pointer",
  },
  selected: {
    backgroundColor: "#26a69a !important",
    color: "white",
    fontWeight: 600,
  },
  select: {
    "&:before": {
      borderColor: "rgb(0, 165, 73)",
    },
    "&:focus": {
      background: "rgb(0, 165, 73)",
    },
  },
  appIcon: {
    color: "#fff",
  },
  backdrop: {
    //zIndex: theme.zIndex.drawer - 2,
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.background.default,
  },
  linearProgress: {
    color: "rgba(1, 174, 78)",
    zIndex: theme.zIndex.drawer + 4,
    height: 7,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  chipGroups: {
    margin: 2,
    color: theme.palette.error.main,
    borderColor: theme.palette.error.light,
  },
  chipLayouts: {
    margin: 2,
    color: theme.palette.success.main,
    borderColor: theme.palette.success.light,
  },
  sideBarButton: {
    backgroundColor: "transparent",
    height: "calc(100% - 14px)",
    marginTop: 6,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  iFrameSimple: {
    padding: "auto",
    height: "100vh",
    //height: '100%',
    overflow: "hidden",
    marginBottom: "-7px",
    border: "0px",
    zIndex: 0,
  },
  pageContentSimple: {
    padding: "auto",
    //height: '88vh',
    height: `calc(100% - ${43}px)`,
    overflow: "hidden",
    marginBottom: "-7px",
    border: "0px",
    zIndex: 0,
    //paddingLeft: 'calc(5%)',
    backgroundColor: "white",
  },
  input: {
    height: 15,
  },
  containerTab: {
    borderBottomColor: theme.palette.primary.main,
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
  },
  logoIframeControl: {
    maxWidth: 80,
    cursor: "pointer",
  },
  administrationPaper: {
    margin: "70px 30px 30px 30px",
  },
  iconHelp: {
    color: "white",
    marginLeft: "auto",
    marginRight: 0,
  },
  star: {
    color: "rgb(218, 197, 0)",
    cursor: "pointer",
  },
  iconSource: {
    textAlign: "center",
  },

  menuItemCustomReset: {
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "#fff !important",
    fontWeight: "normal !important",
  },
  divider: {
    background: "rgba(255, 255, 255, 0.10)",
  },
}));

export const theme = createTheme({
  palette: {
    primary: green,
  },
});
